function checkWebpFeature(feature, callback) {
  const kTestImages = {
    1: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    2: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    3: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    4: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
  }
  const img = new Image()
  img.onload = () => {
    const result = img.width > 0 && img.height > 0
    callback(feature, result)
  }
  img.onerror = () => {
    callback(feature, false)
  }
  img.src = `data:image/webp;base64,${kTestImages[feature]}`
}

let _webpSupported = true

checkWebpFeature(2, (_feature, result) => {
  if (!result) {
    _webpSupported = false
    document.body.classList.add('nowebp')
  }
})

export const webpSupported = () => {
  return _webpSupported
}
let _canvasWebpSupport = null

/**
 * 检测 Canvas 是否支持 webp 编码
 * 通过实际测试 canvas.toDataURL 是否能输出 webp 格式
 * @returns {boolean} 是否支持 webp 编码
 */
export const canvasSupportsWebp = () => {
  // 如果已经检测过，直接返回缓存结果
  if (_canvasWebpSupport !== null) {
    return _canvasWebpSupport;
  }
  try {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;

    // 尝试输出 webp 格式的 dataURL
    const dataUrl = canvas.toDataURL("image/webp");
    // 检查返回的 dataURL 是否真的是 webp 格式
    // 如果浏览器不支持，会回退到 PNG 格式
    _canvasWebpSupport = dataUrl.indexOf("data:image/webp") === 0;
  } catch (e) {
    _canvasWebpSupport = false;
  }
  return _canvasWebpSupport;
};
